import { createStore } from 'vuex';
import env from '@/env';
import about from './modules/about';
import app from './modules/app';
import browse from './modules/browse';
import chart from './modules/chart';
import dashboard from './modules/dashboard';
import insight from './modules/insight';
import leaderboards from './modules/leaderboards';
import market from './modules/market';
import notifications from './modules/notifications';
import onboarding from './modules/onboarding';
import overlay from './modules/overlay';
import pinning from './modules/pinning';
import popup from './modules/popup';
import profile from './modules/profile';
import search from './modules/search';
import support from './modules/support';
import trade from './modules/trade';
import user from './modules/user';
import wallet from './modules/wallet';
import watchlist from './modules/watchlist';
import whatisnew from './modules/whatisnew';
import widgets from './modules/widgets';

export default createStore({
  modules: {
    about,
    app,
    browse,
    chart,
    market,
    overlay,
    popup,
    search,
    support,
    trade,
    user,
    wallet,
    profile,
    notifications,
    insight,
    dashboard,
    leaderboards,
    watchlist,
    onboarding,
    whatisnew,
    ...(env.PINNING_ENABLED ? { pinning } : {}),
    widgets,
  },
  strict: env.NODE_ENV !== 'production',
});
